import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "border-join-bevel-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", transform: "translate(3.5 3.5)" },
        React.createElement("rect", { width: 2, height: 2, x: 4, y: 4, rx: 1 }),
        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M5 6v4m1-5h4m0-5H5L0 5v5" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
